export function formatCHF(value) {
  if (value === null || value === undefined) return null;
  return `CHF ${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.–`;
}
